import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { REFERRAL_ANNUAL } from '../../../utils/backend-api/subscribe';
import { CustomToaster } from '../../BaseUI';
import SubscriptionForm from '../../SubscriptionForm';
import PlanOptions from './PlanOptions';

const queryClient = new QueryClient();

interface ReferralSubscription {
  referringSubName: string;
  referringSubGuid: string;
  currentTrialEndDate: string;
  prefilledUserName?: string;
  prefilledUserEmail?: string;
  stripeCustomerId?: string;
}

const Subscription = ({
  referringSubName,
  referringSubGuid,
  currentTrialEndDate,
  prefilledUserName,
  prefilledUserEmail,
  stripeCustomerId,
}: ReferralSubscription) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomToaster />
      <PlanOptions referringSubName={referringSubName} />
      <SubscriptionForm
        buttonText="Start 14-Day Free Trial"
        currentPlan={REFERRAL_ANNUAL}
        referringSubscriberGuid={referringSubGuid}
        referringSubscriberName={referringSubName}
        currentTrialEndDate={currentTrialEndDate}
        prefilledUserName={prefilledUserName}
        prefilledUserEmail={prefilledUserEmail}
        stripeCustomerId={stripeCustomerId}
      />
    </QueryClientProvider>
  );
};

export default Subscription;
